import React from 'react';
import ReactMarkdown from 'react-markdown';
import type { Components } from 'react-markdown';
import { Box, Typography } from '@mui/material';

// AI summaries come back as a short Markdown block: a bold one-line verdict, then a few labeled bullets. Older or
// unformatted answers (plain paragraphs) render fine too. Raw HTML is never rendered.
const components: Components = {
  p: ({ children }) => (
    <Typography variant="body2" sx={{ lineHeight: 1.6, mb: 1, '&:last-child': { mb: 0 } }}>
      {children}
    </Typography>
  ),
  ul: ({ children }) => (
    <Box component="ul" sx={{ m: 0, pl: 2.5, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
      {children}
    </Box>
  ),
  ol: ({ children }) => (
    <Box component="ol" sx={{ m: 0, pl: 2.5, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
      {children}
    </Box>
  ),
  li: ({ children }) => (
    <Typography component="li" variant="body2" sx={{ lineHeight: 1.6, '&::marker': { color: 'primary.main' } }}>
      {children}
    </Typography>
  ),
  strong: ({ children }) => (
    <Box component="strong" sx={{ fontWeight: 600, color: 'text.primary' }}>
      {children}
    </Box>
  ),
  // Headings shouldn't appear, but keep them small if they do.
  h1: ({ children }) => <Typography variant="subtitle2">{children}</Typography>,
  h2: ({ children }) => <Typography variant="subtitle2">{children}</Typography>,
  h3: ({ children }) => <Typography variant="subtitle2">{children}</Typography>,
};

export const AISummaryText: React.FC<{ text: string }> = ({ text }) => (
  <Box sx={{ '& > ul, & > ol': { mt: 0.25 } }}>
    <ReactMarkdown components={components}>{text}</ReactMarkdown>
  </Box>
);
